<script setup lang="ts">
import { Button } from '@youcan/celeste';
import BannerImg from '@/assets/svg/announcements/ship/banner-illustrations.webp';
import pointBlur from '@/assets/svg/announcements/ship/point-blur.webp';
import ycBackgroundLogo from '@/assets/svg/announcements/ship/yc-background-logo.svg';

defineEmits(['close']);

const page = usePage();
</script>

<template>
  <div class="wrapper">
    <div class="youcan-logoicon">
      <img :src="pointBlur" class="point-blur">
      <img height="100%" :src="ycBackgroundLogo">
    </div>

    <div class="wrapper-content">
      <div class="content" dir="rtl">
        <div class="banner-content">
          <h3 class="title">
            جديد معانا = عرض زوين!
          </h3>
          <p class="text">
            عرض مدى الحياة كي الرباط كي العيون
            ليفري للمغرب كامل غير بـ 35 درهم مدى الحياة!! يلاه بالي قبل مايسالي !
          </p>
          <Button
            class="cta-button"
            target="_blank"
            as="a"
            :href="`${page.props.ship_base_url}/back-office`"
          >
            ابدأ الآن
          </Button>
        </div>
        <img :src="BannerImg" class="banner-img">
      </div>
      <button class="close" @click="$emit('close')">
        <i class="i-celeste-close-large-fill" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* stylelint-disable */
.wrapper {
  position: relative;
  padding: 24px;
  border: 1px solid #63535a;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(48, 31, 39, 1) 20%, rgba(32, 19, 26, 1) 100%);
  overflow: hidden;

  .wrapper-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacing-16);
    height: 100%;
  }
}

.close {
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: #442734;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-bg-white-0);
  border: 1px solid #6f5d66;
  cursor: pointer;
  inset-inline-start: 0;

  [dir='rtl'] &,
  & {
    direction: ltr;
    right: unset;
  }
}

.youcan-logoicon {
  position: absolute;
  top: -20%;
  width: 65%;
  height: 65%;
  z-index: 0;
  height: auto;
  inset-inline-start: 0;

  [dir='rtl'] &,
  & {
    direction: ltr;
    left: -140px;
  }

  .point-blur {
    position: absolute;
    top: 50%;
    left: 50%;

    [dir='rtl'] &,
    & {
      transform: translate(-50%, -50%);
    }
  }
}

.content {
  display: flex;
  gap: var(--spacing-8);
  align-items: center;
  text-align: initial;

  &,
  p {
    color: var(--color-bg-white-0);
  }

  .banner-img {
    transform: scale(1.1);
    height: 130px;
    width: auto;

    @screen lt-lg {
      display: none;
    }
  }
}

.banner-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  .title {
    color: var(--text-strong-950);
    font: var(--title-h6-title);
    font-weight: 600;
  }

  .text {
    font: var(--subheading-sm);
  }

  .close {
    position: absolute;
    z-index: 10;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }

  .banner-img {
    position: absolute;
    top: 0;
    right: 30px;
    bottom: 0;
    height: 100%;
  }

  .cta-button {
    margin-top: var(--spacing-8);
  }
}
</style>
